var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitterChannelIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.6665,
    cy: 10,
    r: 10,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3181_23402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5051 5.46973H15.0188L11.7118 9.2495L15.6023 14.3929H12.556L10.1701 11.2735L7.44006 14.3929H5.92541L9.46265 10.35L5.73047 5.46973H8.85404L11.0107 8.32103L13.5051 5.46973ZM12.9738 13.4869H13.8126L8.39827 6.32818H7.49818L12.9738 13.4869Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3181_23402"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.7692,
    height: 10.7692,
    fill: "white",
    transform: "translate(5.28174 4.61523)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterChannelIcon);
export default __webpack_public_path__ + "static/media/twitter-channel-icon.efb9ce08f5f90717cea7b7290ef3a411.svg";
export { ForwardRef as ReactComponent };